import type { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'

export type XeroMappingsPayload =
  Dashboardv99990101Api.PutProduct.PutProductBody['xeroLedgerAccountMappings']

type XeroMappingIds = {
  deferredId?: string
  recognizedId?: string
  unbilledId?: string
}

export const buildXeroMappingsForUpdate = ({
  deferredId,
  recognizedId,
  unbilledId
}: XeroMappingIds): NonNullable<XeroMappingsPayload> => {
  const entries = [
    { mappableLedgerAccount: 'DEFERRED_REVENUE' as const, id: deferredId },
    { mappableLedgerAccount: 'RECOGNIZED_REVENUE' as const, id: recognizedId },
    { mappableLedgerAccount: 'UNBILLED_REVENUE' as const, id: unbilledId }
  ]

  return entries.flatMap(({ mappableLedgerAccount, id }) =>
    id ? [{ mappableLedgerAccount, xeroLedgerAccountMappingId: id }] : []
  )
}

export const buildXeroMappingsForCreate = (
  ids: XeroMappingIds
): XeroMappingsPayload => {
  const mappings = buildXeroMappingsForUpdate(ids)
  return mappings.length > 0 ? mappings : undefined
}
